import React from "react";
import { Stack, Typography } from "@mui/material";
import { ErrorOutline } from "@mui/icons-material";
import { FlowShell, FlowHeader, SecondaryButton } from "./ui";

/** Shown when the browser cannot do WebAuthn. Ceremonies do not proceed. */
export default function WebauthnUnsupported({ onBack }) {
  return (
    <FlowShell>
      <FlowHeader
        icon={<ErrorOutline sx={{ fontSize: 30 }} />}
        title="This browser can't be secured"
        subtitle="Your browser doesn't support the hardware security this portal requires."
      />
      <Stack gap={1} sx={{ mt: 1 }}>
        <Typography sx={{ fontSize: 13, color: "var(--text-2)", lineHeight: 1.6 }}>
          Please sign in using an up-to-date version of Chrome, Edge, Safari, or Firefox on a device
          with a fingerprint reader, Windows Hello, Touch ID, or a security key.
        </Typography>
      </Stack>
      {onBack && <SecondaryButton onClick={onBack}>Back to sign in</SecondaryButton>}
    </FlowShell>
  );
}
